module.exports = __webpack_public_path__ + "img/zol.51ed0beb.webp";